

window.addEventListener("load", function () {
  document.querySelectorAll(".reelUp_verified").forEach(function (element) {
    element.style.display = "none";
  });
});

$(document).ready(function () {
  function initSlick() {
    if ($(window).width() < 960) { 
      if (!$('.test').hasClass('slick-initialized')) {
        $('.test').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 4, 
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 430,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    } else {
      if ($('.test').hasClass('slick-initialized')) {
        $('.test').slick('unslick');
      }
    }
  }
  initSlick();

  $(window).resize(function () {
    initSlick();
  });
});
